import 'Styles/modals.scss';
import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import { goBack } from 'react-router-redux';

import Modal from 'Components/modals/ModalComponent';

import { authenticate } from 'Actions/authenticateActions';
import { displayNotification } from 'Actions/UiActions';

class LoginModalComponent extends React.Component {
	shouldComponentUpdate( nextProps ) {
		return ( nextProps.isOpen !== this.props.isOpen );
	}

	componentDidUpdate( prevProps ) {
		if( prevProps.isOpen === false && prevProps.isOpen !== this.props.isOpen ) {
			// using pushState to avoid popstate to be triggered
			history.pushState( { topifyExtra: true, type: 'loginModal' }, '', window.location );
		}
	}

	hideModal = () => {
		if( this.props.isOpen ) {
			this.props.dispatch( goBack() );
		}
	};

	validateLogin() {
		return ( this.username && /[^\s]+/.test( this.username.value ) && this.password && /.+/.test( this.password.value ) );
	}

	submitForm = ( e ) => {
		e.preventDefault();

		if( this.validateLogin() ) {
			const data = {
				username: this.username.value,
				password: this.password.value,
				social: false
			};
			this.props.dispatch( authenticate( data ) );
		} else {
			displayNotification( 'error', 'Please provide a valid User name and Password', { force: true } );
			return false;
		}
	};

	socialLogin( provider ) {
		const data = {
			provider: provider,
			social: true
		};
		this.props.dispatch( authenticate( data ) );

	}

	buildSocialButton() {
		let button = null,
			buttons = [];

		if( this.props.socialOptions && this.props.socialOptions.facebook ) {
			button = <input key="fb" className="button facebook" type="button" value="Facebook" onClick={ () => this.socialLogin( 'facebook' ) }/>;
			buttons.push( button );
		}
		if( this.props.socialOptions && this.props.socialOptions.google ) {
			button = <input key="g+" className="button google" type="button" value="Google" onClick={ () => this.socialLogin( 'google' ) } />;
			buttons.push( button );
		}
		if( this.props.socialOptions && this.props.socialOptions.twitter ) {
			button = <input key="tw" className="button twitter" type="button" value="Twitter" onClick={ () => this.socialLogin( 'twitter' ) } />;
			buttons.push( button );
		}

		return ( buttons.length ) ?
			<div>
				<div className="login-modal-register">
					<span>Or Continue with:</span>
				</div>
				<div key="social-buttons" className="modal-buttons social-buttons block-buttons">{ buttons }</div>
			</div> :
			<div className="login-modal-register">
				<span>Don't have an account?</span>
				<a href={ this.props.registerUrl }>Register with the forum</a>
			</div>;
	}

	render() {
		return (
			<Modal isOpen={this.props.isOpen} onClickOutsideWindow={this.hideModal} className="login-modal">
				<h2>Sign In</h2>
				<h3>to the Current Forum</h3>

				<form className="modal-form" onSubmit={this.submitForm}>
					<input ref={ ( u ) => this.username = u } type="text" placeholder="User Name"/>
					<input ref={ ( p ) => this.password = p } type="password" placeholder="Password"/>
					<div className="modal-buttons">
						<input className="action-button" type="submit" value="Sign In"/>
						<input className="cancel-button" type="button" value="Cancel" onClick={this.hideModal}/>
					</div>
				</form>
				{ this.buildSocialButton() }
			</Modal>
		);
	}
}

LoginModalComponent.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	dispatch: PropTypes.func.isRequired
};

const mapStateToProps = ( state ) => {
	return {
		isOpen: state.ui.loginModalOpened,
		socialOptions: state.ustate.socialOptions,
		registerUrl: state.ustate.registerUrl
	}
};

export default connect( mapStateToProps )( LoginModalComponent );


// WEBPACK FOOTER //
// ./src/components/modals/LoginModalComponent.js